<template>
  <v-card width="100%" class="edn-image" :elevation="getCardDisplay ? 2 : 0">
    <v-sheet class="ma-0 pa-0" :color="getCardDisplay ? '#f1f1f1' : ''">
      <v-container :class="getCardDisplay ? '':'pa-0'">
        <v-row :class="[getCardDisplay ? 'pt-0' : '','img-file--row']" align="center">
          <v-col v-if="displayMode == 2" :class="[getCardDisplay && srcType == 'edn-url' ? 'pt-0' : getCardDisplay && srcType == 'edn-file'  ? 'pb-3' : '', 'pa-2 py-0']" 
          cols="auto">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div @mouseover="imgMenuHovered = true" @mouseout="imgMenuHovered = false" v-bind="attrs" v-on="on">
                  <v-icon :color="imgMenuHovered ? 'primary' : ''">{{menuIcon}}</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item
                  :disabled="item.selected"
                  :class="item.selected ? 'selected' : ''"
                  @click="changeInputType(item)"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col class="pa-2 py-0" v-if="!getCardDisplay" cols="auto">
            <edn-dialog
              @finishedLoading="loadingState(false)"
              @errorEvent="getImgError()"
              :disabled="isUrlEmpty || imgError"
              v-model="dialog"
            >
              <template v-slot:activator>
                <v-avatar :class="{ disabled: isUrlEmpty || imgError }">
                  <v-img
                    :class="[!(isUrlEmpty || imgError) ? 'preview-ready' : '', 'preview-image']"
                    @mouseover="imageHover = !(isUrlEmpty || imgError) ? true : false"
                    @mouseout="imageHover = false"
                    @load="loadingState(false)"
                    ref="imgPreview"
                    @error="getImgError()"
                    :lazy-src="lazyImg"
                    :src="getImageSrc"
                  >
                    <v-icon class="expand-icon" v-if="imageHover" color="#fff">mdi-arrow-expand</v-icon>
                  </v-img>
                </v-avatar>
              </template>
              <template v-slot:modal-content>
                <v-img maxHeight="calc(100vh - 180px)" contain :src="getImageSrc"></v-img>
              </template>
            </edn-dialog>
          </v-col>
          <v-col
            :class="[
              getCardDisplay ? 'pl-0' : '',
              srcType == 'edn-file' && !$attrs.rdonly && !getCardDisplay
                ? 'pa-2 py-0 pb-1'
                : !$attrs.rdonly && getCardDisplay
                ? 'pa-2 py-0 pb-0 pt-3'
                : 'pa-2 py-0 pt-0',
            ]"
          >
            <component
              :hideDetails="$attrs.rdonly"
              :css-class="getCptCssClass"
              :placeholder="getPlaceholder"
              :pattern="pattern"
              :error-messages="getErrorMessages"
              :is="srcType"
              :hide-details="getCardDisplay ? 'auto' : false"
              :flat="getCardDisplay"
              :filled="getCardDisplay || $attrs.filled"
              v-model="Value"
              :acceptFormat="getImgExtension"
              :error="imgError"
              :loading="loading"
              :show-size="1000"
              v-on="$listeners"
              v-bind="$attrs"
              @getImage="dataImage = $event"
              @click:clear="$emit('uploadFile', null)"
              @blur="imgError = false"
              @change="updateValue"
              @keydown="keydownAction($event)"
              @uploadFile="loadingState(true)"
            >
              <template v-if="!$attrs.readonly && displayMode != 0" v-slot:edn-append-outer>
                <v-tooltip :disabled="url == ''" v-model="urlCopied" top>
                  <template v-slot:activator="{ click }">
                    <v-icon :click="click" :disabled="imgError || url == ''" @click="copyLink()"
                      >mdi-content-copy</v-icon
                    >
                  </template>
                  <span>{{ getLinkCopyMsg }}</span>
                </v-tooltip>
              </template>
            </component>
            <edn-field ref="urlInput" v-if="srcType == 'edn-file'" class="hidden-input" :value="url"></edn-field>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-card-text v-if="getCardDisplay">
      <v-col>
        <edn-dialog
          @finishedLoading="loadingState(false)"
          @errorEvent="getImgError()"
          :disabled="isUrlEmpty || imgError"
          v-model="dialog"
        >
          <template v-slot:activator>
            <v-img
              class="preview-image"
              @mouseover="imageHover = true"
              @mouseout="imageHover = false"
              @load="loadingState(false)"
              ref="imgPreview"
              @error="getImgError()"
              :lazy-src="lazyImg"
              :src="getImageSrc"
              contain
              :height="getimageDisplay"
              ><v-icon style="pointer-events: none; font-size: 18px" v-if="imageHover" color="#fff"
                >mdi-arrow-expand</v-icon
              ></v-img
            >
          </template>
          <template v-slot:modal-content>
            <v-img maxHeight="calc(100vh - 180px)" contain :src="getImageSrc"></v-img>
          </template>
        </edn-dialog>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { ednRegex } from './mixins/ednRegex'
import { ednRequired } from './mixins/ednRequired'

export default {
  props: {
    // Taille de l'image de prévisualisation
    imageDisplay: {
      type: String,
      default: () => 'sm',
    },
    // Url de l'image ( externe ou récupérée )
    url: {
      type: String,
      default: () => '',
    },
    // Image par défaut si pas d'image ou si le format est invalide
    lazyImg: {
      type: String,
      default: () => './static/img/default.jpg',
    },
    // Fichier chargé
    file: {
      type: File,
      default: () => undefined,
    },
    // Message à afficher lorsque l'on copie le lien
    linkCopyMsg: {
      type: String,
      default: () => undefined,
    },
    // Affiche le message de copie lorsque l'on copie via raccourcis (crtl c) ou via le bouton à droite
    linkCopyAction: {
      type: Boolean,
      default: () => true,
    },
    // Type d'extension de fichier accepté. Par défaut : extensions de type image
    imgExtension: {
      type:[Array,String],
      default: ()=> 'image/*'    
    },
    // Icône du menu de choix du type d'upload (url ou fichier)
    menuIcon: {
      type:String,
      default: ()=> 'mdi-menu'    
    },
    /** Mode d'affichage du composant: 1 - Fichier, 2 - Url, 3 - Les deux */
    displayMode:{
      type:Number,
      default: ()=> 3
    }
  },
  data() {
    return {
      // rules: [(value) => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!'],
      // items: [
      //   { title: this.$vuetify.lang.t('$vuetify.image.fileMsg'), input: 'edn-file', selected: false },
      //   { title: this.$vuetify.lang.t('$vuetify.image.imgMsg'), input: 'edn-url', selected: false },
      // ], // différents types de champs affichés dans le composant
      srcType: 'edn-file', // type de champs affichés par défaut
      imgError: false, // indique si l'image est invalide
      oimageDisplay: {
        sm: '50',
        md: '100',
        lg: '150',
        xl: '250',
      }, // taille des différentes images de prévisualisation
      dialog: false, // ouverture ou non de la modale pour voir l'image en grand
      urlCopied: false, // indique si l'url a été copiée
      dataImage: null, // blob de l'image envoyé par edn-file
      control: false, // enregistre la touche control de l'utilisateur dans le cadre du copier coller (ctrl c)
      loading: false, // chargement suite au changement d'image
      imageHover: false, // survol de l'image,
      imgMenuHovered: false // survol du menu
    }
  },
  inheritAttrs: false,
  created() {
    if(this.displayMode == 3) this.inputToDisplay();
    else this.inputToDisplay(this.displayMode);
    //Si l'event @uploadFile n'est pas récupéré pour inteprêté l'image côté appelant
    //on finit le loader à l'update de file
    this.$on('update:file', () => {
      if (!this._events.uploadFile) this.loading = false
    })
  },
  watch:{
    /** Met à jour le champs si la props est changé */
    displayMode(val){
      this.inputToDisplay(val)
    }      
  },
  computed: {
    /**
     * Permet de savoir quel format on désire pour avoir une image plus ou moins grand en prévisualisation, par défaut sur sm
     */
    getimageDisplay() {
      return this.oimageDisplay[this.imageDisplay]
    },
    /**
     * Détermine si l'url est remplie
     */
    isUrlEmpty() {
      return this.url == null || this.url == undefined || this.url == ''
    },
    /**
     * Récupère l'image à afficher dans la prévisualisation
     */
    getImageSrc() {
      if (this.isUrlEmpty) return this.lazyImg
      else if (!this.imgError && this.url) return this.url
      else return this.lazyImg
    },
    /**
     * Permet de savoir quel affichage adopter en fonction de la taille de la prévisualisation
     */
    getCardDisplay() {
      return this.imageDisplay != 'sm'
    },
    /**
     * Si l'image est en erreur ( url invalide ), on affiche le message d'erreur
     */
    getErrorMessages() {
      if (this.imgError) return this.invalidMsg
      else return ''
    },
    /**
     * Récupère la valeur et la met à jour si besoin. Soit on affiche l'url pour coller une url externe, soit on affiche le fichier chargé.
     */
    Value: {
      get() {
        return this.srcType == 'edn-url' ? this.url : this.file
      },
      set(value) {
        if (this.srcType == 'edn-url') this.$emit('update:url', value)
        else this.$emit('update:file', value)
      },
    },
    /**
     * On récupère les règles pour l'url ou pour le file
     */
    getRules() {
      return this.srcType == 'edn-file' ? this.rules : []
    },
    /**
     * Récupère le placeholder d'url et/ou du fichier sinon le placeholder
     */
    getPlaceholder() {
      if (this.$attrs['url-placeholder'] && this.srcType == 'edn-url') return this.$attrs['url-placeholder']
      else if (this.$attrs['file-placeholder'] && this.srcType == 'edn-file') return this.$attrs['file-placeholder']
      else return this.$attrs.placeholder
    },
    /**
     * Envoie les classes css nécéssaires aux composants champs url et file en mode carte
     */
    getCptCssClass() {
      if (this.getCardDisplay) return { input: 'pt-0 edn-image--input card-display', button: 'pb-0', url: 'pb-0' }
      else if (this.$attrs.rdonly) return { input: 'edn-image--input' }
      else if (this.srcType == 'edn-url') 
        return { input: 'pt-2 pl-2 edn-image--input', url: 'py-2', wrapper: this.url != '' ? 'pt-3'  : 'pt-2' }
      else return { input: 'pt-1 edn-image--input', wrapper: 'pt-4' }
    },
    /**
     * Récupère le message de copie personnalisé ou la res par défaut
     */
    getLinkCopyMsg() {
      return this.linkCopyMsg || this.$vuetify.lang.t('$vuetify.pasteContentRes')
    },
    /**
     * Récupère les extensions de fichiers autorisées.
     */
    getImgExtension(){
      return typeof this.imgExtension == 'object' ? 
        this.imgExtension.join() 
        :  typeof this.imgExtension == 'string' ? 
        this.imgExtension 
        : 'image/*' 
    },
    /**
     * Différents types de champs affichés dans le composant
     */
    items() {
      return [
        { 
          title: !this.$vuetify.lang.t('$vuetify.image.fileMsg') ? '' : this.$vuetify.lang.t('$vuetify.image.fileMsg'), 
          input: 'edn-file', 
          selected: false 
        },
        { 
          title: !this.$vuetify.lang.t('$vuetify.image.imgMsg') ? '' : this.$vuetify.lang.t('$vuetify.image.imgMsg'), 
          input: 'edn-url', 
          selected: false
        }
      ]
    },
  },
  methods: {
    /**
     * Permet de passer d'un type de champs à un autre
     */
    changeInputType(item) {
      this.srcType = item.input
      this.items.forEach((item) => {
        if (item.input == this.srcType) item.selected = true
        else item.selected = false
      })
    },
    /**
     * Permet de savoir si l'image est invalide ( url inexistante par exemple )
     */
    getImgError() {
      this.imgError = true
    },
    /**
     * Copie l'url de l'image
     */
    copyLink() {
      let contentUrl =
        this.srcType == 'edn-file' ? this.$refs.urlInput.$el.querySelector('input') : this.$el.querySelector('input')
      contentUrl.select()
      document.execCommand('copy')
      contentUrl.blur()
      if (this.linkCopyAction) this.displayCopyMsg()
    },
    /** Affiche l'inofbulle pour signaler que l'url a été copiée */
    displayCopyMsg() {
      this.urlCopied = true
      setTimeout(() => {
        this.urlCopied = false
        this.control = false
      }, 2000)
    },
    /**
     * Retire le fichier si on renseigne une url externe
     */
    updateValue() {
      return this.srcType == 'edn-url' ? this.$emit('update:file', null) : false
    },
    /**
     * Indique si l'utilisateur a copié l'url
     */
    keydownAction(e) {
      if (!this.linkCopyAction) return false
      if (e.key == 'Control') this.control = true
      if (e.key == 'c' && this.control) this.displayCopyMsg()
    },
    /**
     * Met en chargement le champs ou le contraire
     */
    loadingState(e) {
      this.loading = e
    },
    /** Quel champs afficher. Si on a l'image et l'url on priorise le champs file, si on a que l'url cette dernière et idem pour le fichier,
     *  sinon on affiche le champs file si on a rien */
    inputToDisplay(displayMode = 2) {
      if(displayMode != 2) this.srcType = this.items[displayMode].input
      else if (this.file) this.srcType = 'edn-file'
      else if (this.url) this.srcType = 'edn-url'
      else this.srcType = 'edn-file'
      this.items.find((item) => item.input == this.srcType).selected = true
    },
  },
  mixins: [ednRegex, ednRequired],
}
</script>

<style lang="scss">
.v-list-item--disabled.selected {
  color: var(--v-primary-base);
}
.edn-image .v-avatar {
  border: solid 1px #cecece;
  &.disabled {
    cursor: auto;
  }
}
.edn-image .v-image .v-responsive__content {
  transition: all 0.5s ease-in;
}
.preview-image.preview-ready.v-image:hover .v-responsive__content {
  background: linear-gradient(#00000038, #00000059);
}
.v-icon.expand-icon {
  pointer-events: none;
  font-size: 18px;
  font-weight: 300;
}
.img-file--row{
  height:80px;
}
</style>
